
import { Alert, Button } from "@mui/material";

import { useTranslation } from "react-i18next";
import { Stack } from "@mui/system";
import { ISummaryUsageDTO } from "../../services/setpoint-administration-service/Models";
import { SetpointUsageItem } from "./SetpointUsageItem";
import { SetpointListItemCard } from "./SetpointListItemCard";
import { isMobile, isTablet } from "react-device-detect";

const USAGE_DISPLAY_COUNT = 5;

export type SetpointUsageCardProps = {
    title: string,
    items: ISummaryUsageDTO[],
    alarmColor: string,
    acknowledgeColor: string,
    grouped: boolean;
    onTestOrDisableAction?: () => void;
    hideActions?: boolean;
};

export function SetpointUsageCard({
    title,
    items,
    alarmColor,
    acknowledgeColor,
    grouped,
    onTestOrDisableAction,
    hideActions

}: SetpointUsageCardProps) {

    const isPhone = isMobile && !isTablet;
    
    const { t } = useTranslation();

    const usageItem = items.length ? items[0] : undefined;

    const linkedCount = usageItem !== undefined ? usageItem.totalTagCount - items.length : 0;

    const filteredItems = hideActions ? items : items.slice(0, USAGE_DISPLAY_COUNT);

    const showMore = !hideActions && items.length > USAGE_DISPLAY_COUNT;


    return (

        <SetpointListItemCard title={title}>

            {filteredItems.map((o) =>
                <SetpointUsageItem key={o.tagID} 
                    name=''
                    grouped={grouped}
                    item={o}
                    alarmColor={alarmColor}
                    acknowledgeColor={acknowledgeColor} />
            )}

            {!hideActions && !grouped && linkedCount > 0 ? 
                <Alert severity="info"
                    sx={{
                        marginTop: 1,
                    }}>
                    {t('setpointAdmin.linkedToTagsWarning', {count: linkedCount})}
                </Alert> :
                null
            }


            {!hideActions && !grouped && 
            <Stack component='span' 
                direction={isPhone ? 'column' : 'row'}
                sx={{
                    justifyContent: !isPhone && showMore ? 'space-between' : 'flex-end',
                    marginTop: 1
                }}>

                {
                showMore && <Button size="small" onClick={() => onTestOrDisableAction && onTestOrDisableAction()}>
                    {t('setpointAdmin.andMore', {count: items.length - USAGE_DISPLAY_COUNT})}
                </Button>
                }

                <Button size="small" onClick={() => onTestOrDisableAction && onTestOrDisableAction()}>
                    {t('setpointAdmin.disableTest')}
                </Button>

            </Stack>}

        </SetpointListItemCard>        
    );
}
